
import { Vue, Component, Prop } from 'vue-property-decorator';
import LocaleSwitcher from '@/components/navigation/LocaleSwitcher.vue';

@Component({
	components: { LocaleSwitcher }
})
export default class CompactNavbar extends Vue {
	@Prop({ type: Object, required: true }) private restaurant!: Restaurant;

	private get imageURL(): string {
		if (process.env.NODE_ENV === 'development') {
			return `${this.restaurant.image}`;
		}
		return `${process.env.VUE_APP_IMAGE_BUCKET}/${this.restaurant.image}`;
	}
}
